<template>
  <tr>
    <td>
      <div class="flex h-full w-full items-start">
        <div>{{ trigger.name }}</div>
      </div>
    </td>
    <td>
      <div class="flex h-full w-full items-start">
        <div>{{ upperCaseEachWord(displayTriggerType) }}</div>
      </div>
    </td>
    <td>
      <div class="flex h-full w-full items-start">
        <ul class="list-deleted-trigger">
          <li v-for="prompt in triggerPrompts.slice(0, showPromptEntries)" :key="prompt.id">
            <router-link :to="getPromptLink(prompt.id, $route.params.aid)">{{
              prompt.name
            }}</router-link>
            <v-chip
              v-if="prompt.chip"
              size="x-small"
              label
              :color="prompt.chip.color"
              class="ml-2"
              >{{ prompt.chip.label }}</v-chip
            >
          </li>
          <template v-if="triggerPrompts.length > 3">
            <template v-if="showPromptEntries < triggerPrompts.length">
              <li>...</li>
              <button class="text-blue-50" @click="showPromptEntries = triggerPrompts.length">
                Show more
              </button>
            </template>
            <template v-else-if="showPromptEntries === triggerPrompts.length">
              <button class="text-blue-50" @click="showPromptEntries = 3">Show less</button>
            </template>
          </template>
        </ul>
      </div>
    </td>
    <td>
      <div class="flex h-full w-full items-start">
        <div class="text-body text-grey-1 max-w-44">
          <div>
            Page/Screen:
            <div class="text-black-2 wrap-break-word">
              {{ displayPage(trigger) }}
            </div>
          </div>
          <div>
            Click on:
            <div v-if="trigger.click_id" class="settings-triggers-tbl-ea trig-clickid text-black-2">
              {{ trigger.click_id }}
            </div>
            <div v-else class="setting-empty-val">N/A</div>
          </div>
          <div>
            Advanced:
            <div v-if="displayCustomTrigger" class="settings-triggers-tbl-ea text-black-2">
              {{ displayCustomTrigger }}
            </div>
            <div v-else class="setting-empty-val">N/A</div>
          </div>
          <div>
            Regex:
            <div class="settings-triggers-tbl-ea text-black-2">
              <div>{{ regexDisplay(trigger) }}</div>
            </div>
          </div>
        </div>
      </div>
    </td>
    <template v-if="isPushEnabled">
      <td class="tbl-col-tr">{{ trigger.event_name }}</td>
      <td class="tbl-col-tr">
        {{ objectToString(trigger.event_attributes) }}
      </td>
    </template>
    <td align="right">
      <div class="flex h-full w-full items-start">
        <div class="settings-triggers-tbl-btn">
          <RfButtonNew type="table" @click="$emit('edit')">
            <RfEyeOpenIcon v-if="!!userStore.isDisabledWithMessage" class="fill-beige-50 h-6 w-6" />
            <RfEditIcon v-else class="fill-beige-50 h-6 w-6" />
          </RfButtonNew>
          <RfButtonNew
            type="table"
            :disabled="userStore.isDisabledWithMessage"
            @click="$emit('remove')"
          >
            <RfDeleteIcon class="fill-vermillion-50 h-6 w-6" />
          </RfButtonNew>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import StringUtils from "@/utils/StringUtils";
import { getPromptLink } from "@/utils/getLink";
import {
  displayCustomInterval,
  displayCustomTrigger,
  displayPage,
  regexDisplay,
} from "@/utils/triggerHelpers";
import { objectToString } from "@/utils/objectUtils";
import { useUserStore } from "@/pinia/userStore";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfEditIcon from "@/components/icons/RfEditIcon.vue";
import RfEyeOpenIcon from "@/components/icons/RfEyeOpenIcon.vue";
import RfDeleteIcon from "@/components/icons/RfDeleteIcon.vue";

export default {
  components: { RfButtonNew, RfEditIcon, RfDeleteIcon, RfEyeOpenIcon },
  props: {
    trigger: Object,
    customTriggers: Array,
    retentions: Array,
    isPushEnabled: { type: Boolean, default: false },
  },
  setup: () => ({
    regexDisplay,
    displayPage,
    getPromptLink,
    upperCaseEachWord: StringUtils.upperCaseEachWord,
    objectToString,
    userStore: useUserStore(),
  }),
  data: () => ({ showPromptEntries: 3 }),
  computed: {
    displayCustomInterval() {
      return displayCustomInterval(this.trigger);
    },
    displayClickCount() {
      return this.trigger.trigger_type !== "device" ? this.trigger.click_count_threshold : null;
    },
    displayTriggerType() {
      return this.trigger.trigger_type === "easy_button" ? "live" : this.trigger.trigger_type;
    },
    displayCustomTrigger() {
      return displayCustomTrigger(this.trigger, this.customTriggers);
    },
    triggerPrompts() {
      return this.retentions
        .filter(ret => !!ret.triggers.find(({ id }) => id === this.trigger.id))
        .map(p => {
          const e = p.experiment;
          let chip = null;
          if (e) {
            if (e.is_active) chip = { label: "Active", color: "success" };
            else if (e.is_completed) chip = { label: "Completed", color: "grey" };
            else chip = { label: "Draft", color: "grey-lighten-1" };
          }
          return { ...p, chip };
        });
    },
  },
};
</script>
